import { render, staticRenderFns } from "./VideoPopup.vue?vue&type=template&id=279eb975&v-if=videoUrl&"
import script from "./VideoPopup.vue?vue&type=script&lang=ts&"
export * from "./VideoPopup.vue?vue&type=script&lang=ts&"
import style0 from "./VideoPopup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports